import {Injectable} from '@angular/core';
import {LocationOption} from '../api';
import {TaAppStore} from '../state/clcta-store';
import {TaSearchDatasource} from '../datasources/ta-search-datasource';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  constructor(
    private taSearchDatasource: TaSearchDatasource,
    private store: TaAppStore,
  ) {}

  loadLocations(): void {
    this.taSearchDatasource.loadLocationOptions();
  }

  outOfRegion(name: string): boolean {
    let location: LocationOption | undefined = this.store.availableLocations().find(location => location.name === name);
    if (location === undefined || location.inRegion === undefined) {
      return false;
    }
    return !(location.inRegion);
  }
}
